import { SVGProps } from 'react';

interface IProps {
  pathProps?: SVGProps<SVGPathElement>;
}

const AddIcon = ({ pathProps }: IProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_31010_101240)">
      <path
        d="M7.99967 5.33301V10.6663M5.33301 7.99967H10.6663M14.6663 7.99967C14.6663 11.6816 11.6816 14.6663 7.99967 14.6663C4.31778 14.6663 1.33301 11.6816 1.33301 7.99967C1.33301 4.31778 4.31778 1.33301 7.99967 1.33301C11.6816 1.33301 14.6663 4.31778 14.6663 7.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </g>
    <defs>
      <clipPath id="clip0_31010_101240">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default AddIcon;
